import { handleActions } from "redux-actions";
import { IResponse } from "middleware/api";

import {
    CONTACT_GROUP_CREATE_SUCCESS,
    CONTACT_GROUP_EDIT_START,
    CONTACT_GROUP_EDIT_SUCCESS,
    CONTACT_GROUP_FETCH_START,
    CONTACT_GROUP_FETCH_SUCCESS,
    CONTACT_GROUP_RESET,
    CONTACT_GROUP_TAB_CHANGE,
} from "constants/action-types";

export interface IState {
    error?: Error;
    errorCode?: number;
    isFetching: boolean;
    isPatching: boolean;
    result: any;
    selectedTab: string;
}

export const initialState: IState = {
    error: undefined,
    errorCode: undefined,
    isFetching: false,
    isPatching: false,
    result: [],
    selectedTab: "recipients",
};

export const contactGroupReducer = handleActions<IState, any>(
    {
        [CONTACT_GROUP_FETCH_START]: (state: IState): IState => {
            return {
                ...state,
                isFetching: true,
            };
        },
        [CONTACT_GROUP_FETCH_SUCCESS]: (state: IState, { payload, error }: IResponse): IState => {
            let result = payload.result;
            let errorCode;
            if (error) {
                result = state.result;
                errorCode = payload.errorCode;
            }

            return {
                ...state,
                error: error ? payload : undefined,
                errorCode,
                isFetching: false,
                result,
            };
        },
        [CONTACT_GROUP_EDIT_START]: (state: IState): IState => {
            return {
                ...state,
                isPatching: true,
            };
        },
        [CONTACT_GROUP_EDIT_SUCCESS]: (state: IState): IState => {
            return {
                ...state,
                isPatching: false,
            };
        },
        [CONTACT_GROUP_TAB_CHANGE]: (state: IState, { payload }): IState => {
            return {
                ...state,
                selectedTab: payload,
            };
        },
        [CONTACT_GROUP_RESET]: (): IState => {
            return {
                error: undefined,
                errorCode: undefined,
                isFetching: false,
                isPatching: false,
                result: [],
                selectedTab: "recipients",
            };
        },
        [CONTACT_GROUP_CREATE_SUCCESS]: (state: IState, { payload, error }: IResponse): IState => {
            let result;
            if (error) {
                result = [];
            } else {
                result = payload;
            }

            return {
                ...state,
                error: error ? payload : undefined,
                isFetching: false,
                result,
            };
        },
    } as any,
    initialState
);
